const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Woodrow", "Woodrow R", "Woodrow Reese"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Woodrow", "Woodrow R", "Woodrow Reese"],
	},

	{
		page: "resume",
		description:
			"My experience as a frontend software engineer, backend web developer, MERN stack: mongodb, express, react, node. Recent graduate with a Bachelor's of Computer Science at UMASS Boston",
		keywords: ["Woodrow", "Woodrow R", "Woodrow Reese"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Woodrow", "Woodrow R", "Woodrow Reese"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Woodrow", "Woodrow R", "Woodrow Reese"],
	},
];

export default SEO;
